import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../../utils/report-utils.js";

const reportId = "despatches-by-nature-group";
const reportName = "Despachos por grupo de natureza";
const DispatchesByNatureGroup= ({data}) => {
  useEffect(() => {
    const allLabels = [];
    const allValues = [];

    for (const item of data) {
      allLabels.push(item.nature_group);
      allValues.push(item.qty);
    }

    const chartLabels = allLabels.slice(0, 10);
    const chartValues = allValues.slice(0, 10);

    GraphicUtils.barChart(reportId, chartValues, chartLabels, true);
    data && data.length > 0 && ReportUtils.createExportableTable(allLabels, allValues, "Desp. por grupo de natureza");
  }, [data]);

  return (
    <>
      <div className="chart-report">
        <span className="chart-title">{reportName} {data?.length >= 10 ? ' (TOP 10)' : ''}</span>
        <div className="mt-3" id={reportId}></div>
      </div>
    </>
  );
};

export default DispatchesByNatureGroup;